import { TransportMode } from '@hazmatsuite-next/ui';
import { EnumPackageType } from './package-type.enum';

export class PackagingModel {
  Id = '';
  InternalId = '';
  ParentId = '';
  Closure = {};
  TransportMode: TransportMode = TransportMode.Unknown;
  PackageType: EnumPackageType = EnumPackageType.NotSet;
  PackagingTitle = '';
  PackagingType = '';
  MaterialIdentification = '';
  MaterialName = '';
  PackagingUnCode = '';
  HasCargoAircraftOnly = this.TransportMode == TransportMode.Air;
  ShippingPaperEntryDangerousGood = '';
  ShippingPaperEntryPackaging = '';
  CountOfPackagings = 0;
  IsEnvironmentallyHazardousEnabled = true;
}
